import XLSX from 'xlsx'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date = new Date(time)
  if (!date) {
    if (typeof time === 'object') {
      date = time
    } else {
      if (typeof time === 'string') {
        if (/^[0-9]+$/.test(time)) {
          // support "1548221490638"
          time = parseInt(time)
        } else {
          // support safari
          // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
          time = time.replace(new RegExp(/-/gm), '/')
        }
      }

      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
  }

  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/***
 * 调整一个字段 匹配范围
 */

export function deletePropery(list, object, arr) {
  for (let property of arr) {
    // indexOf 找不到索引时返回 -1， 是数组最后一个值；
    let index = list.indexOf(property)
    list[index] = list[list.length - 1]
    list.pop()
    // 删除对象不存在的对象 回返回true,成功删除也返回true;
    // 似乎在js哪个新的内容出来之前，delete是最安全的操作，
    delete object[property]
  }
  // console.log("list, object", list, object);
  return { list, object }
}

/**
 * 只赋值对象属性，不复制值；
 * This is just a simple version of deep copy,
 * copy key, without value;
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepCloneWithoutValue(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}

  Object.keys(source).forEach(keys => {
    if (source[keys] && source[keys].constructor === Array) {
      targetObj[keys] = []
    } else if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepCloneWithoutValue(source[keys])
    } else {
      targetObj[keys] = undefined
    }
  })

  return targetObj
}

export function collectApiParam(Desc, actionList) {
  // let list = [];
  let param = {}
  for (let item of actionList) {
    let item_api = item.url + '_api'
    param[item_api] = deepCloneWithoutValue(Desc[item_api].param, true)
  }
  return param
}

// 解析excel 返回数组
export async function resolvingXLSX(file, fields) {
  // debugger;
  // let list = [];
  let bool = true
  let data = await FunctionReadFile(file)
  console.log(data)
  // debugger;
  const workbook = XLSX.read(data.target.result, {
    type: 'binary',
    codepage: 936
  })
  // const workbook = XLSX.read(data.target.result, { type: "string" });
  for (let sheet in workbook.Sheets) {
    const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
      // 参见文档： https://www.npmjs.com/package/xlsx#json
      header: 1
    })
    //若当前sheet没有数据， 退出循环模板格式 错误
    if (sheetArray.length == 0) {
      bool = false
      break
    }
    // sheetArray是对象数组，每一行的数据是个对象
    // let descFields = sheetArray.shift();// 删除第一行
    // XLSX 直接将第一的数据当做对象的属性名
    let keys = sheetArray[0]
    console.log('keys', keys)
    for (let i = 0; i < keys.length; i++) {
      let item = keys[i]
      console.log(
        'item, fields[i]',
        `a${item}a`,
        `a${fields[i]}a`,
        item === fields[i]
      )

      // for (let item of sheetArray) {
      //循环读取 每一行
      // let rowTable = {};
      // for (let key in fields) {
      //   let field = fields[key]
      //   // console.log("item", item, field)
      //   rowTable[key] =
      //     item[field] !== undefined
      //       ? item[field]
      //       : "";
      // }
      // // console.log("rowTable", rowTable);
      // list.push(rowTable);
      if (item !== fields[i]) {
        console.log(
          'item, fields[i]',
          `x${item}x`,
          `X${fields[i]}x`,
          item === fields[i]
        )
        bool = false
        break
      }
    }
  }
  // console.log("before reutrn");
  // return list;
  return bool
}

function FunctionReadFile(file) {
  let fileReader = new FileReader()
  // debugger;
  return new Promise(function(resolve, reject) {
    fileReader.onload = e => {
      if (e.type === 'load') {
        resolve(e)
      } else {
        reject(e)
      }
    }
    fileReader.readAsBinaryString(file)
  })
}

export function isNumber(value) {
  console.log('value isNumber', value, typeof value === 'number')
  typeof value === 'number'
}

export function noop() {}

/**
 * 下拉项的值添加“_api”后缀
 * @param {*} action
 */
export function actionToApi(action) {
  return action + '_api'
}

export function getTime(date) {
  let t = new Date(date)
  if (!t) new Error('时间格式有误')
  return t.getTime()
}

export function numberCompare(a, b) {
  return a - b
}

/**
 * 清除登录信息
 */
export function clearLoginInfo() {
  sessionStorage.removeItem('token')

  // store.commit('resetStore')
  // router.options.isAddDynamicMenuRoutes = false
}

// rfm

// 解析excel 返回数组
export async function rfmResolvingXLSX(file, fields) {
  // debugger;
  let list = []
  let data = await FunctionReadFile(file)
  // debugger;
  const workbook = XLSX.read(data.target.result, { type: 'binary' })
  for (let sheet in workbook.Sheets) {
    const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet])
    //若当前sheet没有数据，则continue
    if (sheetArray.length == 0) {
      continue
    }
    // sheetArray是对象数组，每一行的数据是个对象
    // let descFields = sheetArray.shift();// 删除第一行
    // XLSX 直接将第一的数据当做对象的属性名
    for (let item of sheetArray) {
      //循环读取 每一行
      let rowTable = {}
      for (let key in fields) {
        let field = fields[key]
        console.log('item', key, field)
        rowTable[key] = item[field] !== undefined ? item[field] : ''
      }
      // console.log("rowTable", rowTable);
      list.push(rowTable)
    }
  }
  // console.log("before reutrn");
  return list
}



// WEBPACK FOOTER //
// ./src/utils/index.js